<script>import DynamicRenderer from "../../components/dynamic-renderer/dynamic-renderer.svelte";
import { getClassPropName } from "../../functions/get-class-prop-name";
import { filterAttrs } from "../helpers";
export let attributes = undefined;
export let link = undefined;
export let openLinkInNewTab = undefined;
export let builderLinkComponent = undefined;
export let text = undefined;
function attrs() {
    return {
        ...filterAttrs(attributes, "on:", false),
        [getClassPropName()]: `${link ? "" : "builder-button"} ${attributes[getClassPropName()] || ""}`,
        ...(link
            ? {
                href: link,
                target: openLinkInNewTab ? "_blank" : undefined,
                role: "link",
            }
            : {
                role: "button",
            }),
    };
}
</script>

<DynamicRenderer
  attributes={attrs()}
  TagName={link ? builderLinkComponent || "a" : "button"}
  actionAttributes={filterAttrs(attributes, "on:", true)}
  >{text}</DynamicRenderer
>